export default __webpack_public_path__ + "77bfb366890047701d4047ab05ad25a2.svg";